import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=39b5001b&"
import script from "./AssetForm.vue?vue&type=script&lang=js&"
export * from "./AssetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports